module.exports = __webpack_public_path__ + "static/media/armor.cd475ef9.png";